import { Fragment } from 'react';
import PropTypes from 'prop-types';

import { getComponentToRender } from './utils/getSliderComponent';
import { ITEM_WIDTH } from './utils/constants';

const SingleSliderTrack = props => {
  const ComponentToRender = getComponentToRender(props.type);

  return (
    <Fragment>
      <div className="slider-track__wrap">
        <div
          className="slider-track__track"
          style={{
            width: `${ITEM_WIDTH}%`,
            left: 0
          }}
        >
          <ComponentToRender key="currentItem" item={props.item} />
        </div>
      </div>
    </Fragment>
  );
};

SingleSliderTrack.propTypes = {
  type: PropTypes.oneOf(['img', 'plan', 'video', 'map']).isRequired,
  item: PropTypes.shape().isRequired
};

export default SingleSliderTrack;
